import "./input-group.scss";

import { Image } from "react-bootstrap";
import { InputGroupOption, InputGroupProps, typedMemo } from "src/types";
import {
  concatClasses,
  formatLabel,
  formatLabelWithCondition,
} from "src/utils";
import { useInputGroup } from "./input-group.hook";

export const InputGroup = typedMemo((props: InputGroupProps) => {
  const {
    name,
    label,
    disabled,
    validationSchema,
    touched,
    error,
    value: selectedOptionId,
    options,
    handleBlur,
    handleChange,
    vertically = false,
    classes,
    classesOption,
    classesLabel = "input-radio--label",
    classesError = "input-radio--error",
    requiredCondition,
  } = props;
  const { imagesSource } = useInputGroup(props);

  const allClassesError = concatClasses(
    classesError,
    touched && error ? "" : "opacity-0"
  );

  const allClassesOption = (index: number) =>
    concatClasses(
      `input-radio--option`,
      ` ${classesOption}`,
      index > 0 && !vertically ? "ms-5" : "",
      vertically ? "mb-3" : "",
      disabled ? "cursor-not-allowed color-disabled" : "cursor-pointer"
    );

  const allClassesOptions = concatClasses(
    vertically ? "input-radio--options-v" : "input-radio--options-h"
  );

  ////////////////////////////////////////////////////////////////////////////////////////////////////

  const Label = (
    <label htmlFor={name} className={classesLabel}>
      {requiredCondition == null && formatLabel(validationSchema, name, label)}
      {requiredCondition != null &&
        formatLabelWithCondition(label, requiredCondition)}
    </label>
  );

  const Error = <p className={allClassesError}>{`${error}`}</p>;

  const Option = ({ id, value }: InputGroupOption, index: number) => (
    <label key={index} className={allClassesOption(index)}>
      <input
        type="radio"
        value={id}
        disabled={disabled}
        checked={selectedOptionId === id}
        name={name}
        onChange={handleChange}
        onBlur={handleBlur}
        hidden
      />
      <Image
        src={
          imagesSource[
            `${selectedOptionId === id ? "full" : "empty"}-${disabled ? "disabled" : "enabled"}`
          ]
        }
        width={18}
        height={18}
        className="m-0 p-0 me-2"
      />
      {value}
    </label>
  );

  const Options = (
    <div className={allClassesOptions}>{options?.map(Option)}</div>
  );

  ////////////////////////////////////////////////////////////////////////////////////////////////////

  return (
    <main id={`input-${name}`} className={classes}>
      {Label}
      {Options}
      {Error}
    </main>
  );
});
